// extracted by mini-css-extract-plugin
export default {"name-button":"TaskTableItem_name-button__ZkBCj","is-selected":"TaskTableItem_is-selected__eZpi-"};